import { CircularProgress, Stack } from '@mui/material';
import React from 'react';
export const DefaultLoader = ({ containerProps, loaderProps }) => {
    return (React.createElement(Stack, { height: "100%", alignItems: "center", justifyContent: "center", ...(containerProps || {}) },
        React.createElement(CircularProgress, { ...(loaderProps || {}) })));
};
